<t4-header></t4-header>
<t4-periodPicker period="day" [(from)]="from" [(to)]="to" (periodChanged)="updateParams()"></t4-periodPicker>
<t4-container>
  <t4-data-table #tbl reportName="PerformedLocationCheckups" [parameters]="queryParameters" headline="" matSort [filterFields]="['Firstname', 'Lastname', 'CompanyName', 'Type', 'InspectionsPerformed','LastInspection','DaysSinceInspection']" [autoGenerateColumns]="false">
    <ng-container matColumnDef="Firstname">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.Maintenance.Reports.PerformedInspections.Table_FirstName' |translate : 'First name' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.Firstname}}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="Lastname">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.Maintenance.Reports.PerformedInspections.Table_Lastname' |translate : 'Last name' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.Lastname}}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="CompanyName">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.Maintenance.Reports.PerformedInspections.Table_CompanyName' |translate : 'Company name' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.CompanyName}}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="Type">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.Maintenance.Reports.PerformedInspections.Table_Type' |translate : 'Type' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.Type }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>
    <ng-container matColumnDef="InspectionsPerformed">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.Maintenance.Reports.PerformedInspections.Table_InspectionsPerformed' |translate : 'Inspections in period' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.InspectionsPerformed }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="LastInspection">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.Maintenance.Reports.PerformedInspections.Table_LastInspection' |translate : 'Last inspection' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.LastInspection | date : 'yyyy-MM-dd' }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

    <ng-container matColumnDef="DaysSinceInspection">
      <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'Turbo.Maintenance.Reports.PerformedInspections.Table_DaysSinceInspection' |translate : 'Days since last inspection' }}</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.DaysSinceInspection }}</mat-cell>
      <mat-footer-cell *matFooterCellDef style="font-weight: bold; background: #eee"></mat-footer-cell>
    </ng-container>

  </t4-data-table>
</t4-container>
